import { FC, createContext, useContext, useState, Dispatch } from "react";

// Context to handle the publish button
export interface IPublishContext {
  publishState: any;
  setPublishState?: Dispatch<any>;
}
const initialPublishContextState: IPublishContext = {
  publishState: false,
  setPublishState: () => {}
};

const PublishContext = createContext<IPublishContext>(initialPublishContextState);
export const usePublishContext = () => useContext(PublishContext);

interface PublishProviderProps {}

const PublishProvider: FC<PublishProviderProps> = props => {
  const [publishState, setPublishState] = useState(null);
  return (
    <PublishContext.Provider value={{publishState, setPublishState}}>
      {props.children}
    </PublishContext.Provider>
  );
};

export default PublishProvider;